import Box from '@/common/components/Box'
import { ChangeHistory } from '@/common/components/ChangeHistory'
import { Checklist } from '@/features/privateCompanyLeadsFunnel/components/Checklist'
import { AddressSection } from '@/features/publicCompanyLeadsFunnel/components/AddressSection'
import { BiddingInformationSection } from '@/features/publicCompanyLeadsFunnel/components/BiddingInformationSection'
import { ContactsSection } from '@/features/publicCompanyLeadsFunnel/components/ContactsSection'
import { FiscalDocumentInformationSection } from '@/features/publicCompanyLeadsFunnel/components/FiscalDocumentInformationSection'
import { GeneralInformationSection } from '@/features/publicCompanyLeadsFunnel/components/GeneralInformationSection'
import { GenericDocumentsSection } from '@/features/publicCompanyLeadsFunnel/components/GenericDocumentsSection'
import { LeadHeader } from '@/features/publicCompanyLeadsFunnel/components/LeadHeader'
import { ResponsibleSection } from '@/features/publicCompanyLeadsFunnel/components/ResponsibleSection'
import { SpecialFees } from '@/features/publicCompanyLeadsFunnel/components/SpecialFees'
import {
  stateStrategy,
  translateStateStrategy,
} from '@/features/publicCompanyLeadsFunnel/constants/stateStrategy.constant'
import usePublicCompanyLeadForm from '@/features/publicCompanyLeadsFunnel/hooks/usePublicCompanyLeadForm'
import { PublicCompanyLeadData } from '@/features/publicCompanyLeadsFunnel/types/publicCompanyLead'
import { FormProvider } from 'react-hook-form'

const LeadCompletedForm = ({
  id,
  publicCompanyLead,
}: {
  id: string
  publicCompanyLead: PublicCompanyLeadData
}) => {
  const useFormMethods = usePublicCompanyLeadForm({ publicCompanyLead })

  return (
    <FormProvider {...useFormMethods}>
      <form>
        <LeadHeader
          publicCompanyLeadId={id}
          display_name={publicCompanyLead.display_name}
          url={publicCompanyLead.general_information?.company_logo?.url}
          showArchiveButton
          archived_at={publicCompanyLead.archived_at}
        />
        <div className="flex gap-6">
          <Box className="w-full flex flex-col gap-6 h-[calc(100vh-130px)] overflow-y-scroll">
            <ResponsibleSection
              publicCompanyLead={publicCompanyLead}
              last_review={publicCompanyLead.last_review}
              disabled
            />
            <BiddingInformationSection
              publicCompanyLeadId={id}
              publicCompanyLeadState={publicCompanyLead.state}
              contractId={publicCompanyLead.contract?.id}
              contractFile={publicCompanyLead.contract?.file}
              bidding_information={publicCompanyLead.bidding_information}
              disabled
            />
            <SpecialFees fee_rule={publicCompanyLead.fee_rule} disabled />
            <FiscalDocumentInformationSection
              fiscal_document_information={publicCompanyLead.fiscal_document_information}
              disabled
            />
            <GeneralInformationSection general_information={publicCompanyLead.general_information} disabled />
            <AddressSection address={publicCompanyLead.address} disabled />
            <ContactsSection
              publicCompanyLeadId={id}
              contacts={publicCompanyLead.contacts}
              leadState={publicCompanyLead.state}
              contact_for_master_user={publicCompanyLead.contact_for_master_user}
              disabled
            />
            <GenericDocumentsSection
              publicCompanyLeadId={id}
              generic_documents={publicCompanyLead.generic_documents}
              disabled
            />
          </Box>
          <div className="flex flex-col gap-4">
            <Checklist
              requirement_list_summary={publicCompanyLead.requirement_list_summary}
              state={translateStateStrategy[stateStrategy[publicCompanyLead.state as keyof typeof stateStrategy]]}
              className="flex flex-col gap-2 justify-between h-[calc((100vh-276px)/2)]"
            />
            <ChangeHistory logs={publicCompanyLead?.logs || []} />
          </div>
        </div>
      </form>
    </FormProvider>
  )
}

export default LeadCompletedForm
